import React, { useContext, useEffect, useState } from 'react'
import { useStateWithCallbackLazy } from 'use-state-with-callback'
import { LanguageContext } from '../Language/LanguageContext'
import { Row, Col, Button, Pagination } from 'react-bootstrap'
import { listGallery, deleteAlbum } from '../Network/Gallery'
import { baseURL } from '../Network/Config'
import { Link, useHistory } from 'react-router-dom'
import { Container, Loading } from '../Library'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faImage, faTrash } from '@fortawesome/free-solid-svg-icons'
import { NotifyContext } from '../Library/Notify'
import { setDocumentTitle } from '../AppTitle'
import dayjs from 'dayjs'
import "./Gallery.css"
import { AlertModalContext } from '../Library/AlertModalContext'

function Gallery() {
    const alertModal = useContext(AlertModalContext)
    const history = useHistory()
    const notify = useContext(NotifyContext)
    const langCx = useContext(LanguageContext);
    const lang = langCx.lang.gallery;
    const size = 12;
    const [first, setFirst] = useState(true)
    const [isLoading, setLoading] = useState(false)
    const [page, setPage] = useStateWithCallbackLazy(1);
    const [galleryList, setGalleryList] = useState([]);
    const [lastLength, setLastLength] = useState(0)

    const fetchData = (page, size, loadnew) =>{
        setLoading(true)
        listGallery(page, size,
            (data)=>{
                if(loadnew){
                    
                    setGalleryList(data)
                    if(first){
                        setLastLength(data.length)
                        setFirst(false)
                    }
                }else{
                    data.forEach((item)=>{
                        setGalleryList(oldData => [...oldData, item])
                    })
                    setLastLength(data.length)
                }
                setLoading(false)
            },
            (error)=>{
                notify.showNotify("Something wrong", error.message, 2)
            })
    }
    
    const prevClick = () =>{
        setPage(page - 1, (current)=>{
            fetchData(current, size, true)
        });
    }

    const nextClick = () =>{
        setPage(page + 1, (current)=>{
            fetchData(current, size, true)
        });
    }

    const onDeleteAlbum = (albumId) =>{
        alertModal.setTitle(lang.delete_album)
        alertModal.setDescription(lang.sure_to_delete)
        alertModal.setAlertType("EXTREME")
        alertModal.setButton([
            {
                title: langCx.lang.confirm.ok,
                variant: "danger",
                onClick: ()=>{ 
                    alertModal.setIsShow(false)
                    setLoading(true)
                    deleteAlbum(albumId,
                        ()=>{
                            fetchData(1, size * page, true)
                            notify.showNotify(lang.deleted_album, lang.deleted_album_desc, 0)
                        },
                        (error)=>{
                            notify.showNotify("Something wrong", error.message, 2)
                        })
                }
            },
            {
                title: langCx.lang.confirm.cancel,
                variant: "secondary",
                onClick: ()=>{ 
                    alertModal.setIsShow(false) 
                }
            }
        ])
        alertModal.setIsShow(true)
        // if(window.confirm(lang.sure_to_delete)){
        //     deleteAlbum(albumId,
        //         ()=>{
        //             fetchData(1, size * page, true)
        //         },
        //         (error)=>{
        //             notify.showNotify("Something wrong", error.message, 2)
        //         })
        // }
    }

    const loadMore = () =>{
        var nextPage = page + 1
        fetchData(nextPage, size, false)
        setPage(nextPage)
    }

    const onScroll = (event) =>{
        const target = event.target
        if(target.scrollHeight - target.scrollTop === target.clientHeight){
            if(lastLength >= size){
                loadMore()
            }
        }
    }

    useEffect(()=>{
        setDocumentTitle("Gallery")
        fetchData(page, size, true)
    }, [])

    return (
        <Container topbarTitle={langCx.lang.sidebar.gallery}>
        { isLoading ? <Loading/>: null }
        <div id="gallery">
            {/* <div className="title-header">
                {lang.album}
                <div className="desc">{lang.album_desc}</div>
            </div> */}
            <div className="button-container">
                <Button
                onClick={()=>history.push("/gallery/create")}>
                    {lang.create_album}
                </Button>
                {/* <Pagination>
                    <Pagination.Prev
                    disabled={page === 1}
                    onClick={()=>prevClick()}/>
                    <Pagination.Item 
                    disabled={true}
                    >
                        {page}
                    </Pagination.Item>
                    <Pagination.Next
                    disabled={galleryList.length < size}
                    onClick={()=>nextClick()}
                    />
                </Pagination> */}
            </div>
            <div className="gallery-container" onScroll={onScroll}>
                <Row>
                    { galleryList.map((item, key)=>
                    <Col key={key} sm={6} lg={4}>
                        <GalleryItem
                        to={"/gallery/edit/"+item.albumId}
                        title={item.albumName}
                        images={item.images}
                        date={item.updatedDate}
                        description={item.description}
                        onClickDelete={(e)=>{
                            e.preventDefault()
                            onDeleteAlbum(item.albumId)
                        }}
                        />
                    </Col>
                    )}
                </Row>
                { galleryList.length === 0 ?
                <div className="no-image">
                    <FontAwesomeIcon icon={faImage} className="icon"/>
                    <div>
                        {lang.no_album}
                    </div>
                </div>
                : null
                }
                { lastLength >= size ?
                <div style={{ textAlign: 'center' }}>
                    <Button onClick={()=>loadMore()}>
                        {lang.load_more}
                    </Button>
                </div>
                : null
                }
            </div>
        </div>
        </Container>
    )
}

function GalleryItem(props){
    const langCx = useContext(LanguageContext);
    const lang = langCx.lang.gallery;
    const images = props.images || []

    const convertDate = (toDate) =>{
        let date = new Date(toDate)
        let formatted = dayjs(date).format("D MMMM YYYY H:mm")
        return formatted
    }

    return(
        <Link className="gallery-item" to={props.to}>
            <Row className="preview">
                { images.slice(0, 4).map((item, key)=>
                <Col xs={6} className="image" key={key}>
                    <img src={baseURL+item.imagePath} alt={key} style={{ borderRadius: 8 }}/>
                </Col>
                )}
                { images.length === 0 ?
                <div className="empty-image">
                    <div>
                        <div className="icon">
                            <FontAwesomeIcon icon={faImage}/>
                        </div>
                        <div>
                            {lang.no_image}
                        </div>
                    </div>
                </div>
                : null
                }
            </Row>
            <div className="detail">
                <div className="title">{props.title}</div>
                <div className="subtitle desc">{props.description}</div>
                <div className="bottom">
                    <div className="subtitle">{convertDate(props.date)}</div>
                    <Button
                    variant="danger"
                    size="sm"
                    onClick={props.onClickDelete}
                    >
                        <FontAwesomeIcon icon={faTrash}/>
                    </Button>
                </div>
                
            </div>
        </Link>
    )
}

export default Gallery
